import { atom, useAtomValue } from 'jotai';

/**
 * Tracks whether the Tauri overlay has a valid auth session synced from
 * the main window. True only when both a token exists AND the persisted
 * React Query cache contains a successful `getUser` entry (proving the
 * main app authenticated before the overlay opened). Used by overlay-safe
 * hooks (e.g. `useInboxItemsForRun`) as an alternative to `!!user` which
 * is unavailable under `MinimalProviders`.
 */
export const authTokenSyncedAtom = atom(false);

/** Overlay branch of the identity question. Reads the atom above. */
export const useIsAuthTokenSynced = (): boolean => useAtomValue(authTokenSyncedAtom);
